import { assessPassword } from '../../lib/password'

const SEGMENTS = 4

/** score 0-4 → filled segments and their color (danger → warn → gold → ok). */
function segmentColor(score: number): string {
  if (score <= 1) return 'bg-ostrel-danger'
  if (score === 2) return 'bg-ostrel-warn'
  if (score === 3) return 'bg-ostrel-gold'
  return 'bg-ostrel-ok'
}

/** Live password strength meter (guidance only — the server policy is the
 *  gate, see src/lib/password.ts). Renders nothing for an empty field. */
export function PasswordStrengthMeter({ password }: { password: string }) {
  if (!password) return null
  const { score, label, hint, meetsMinimum } = assessPassword(password)
  const filled = Math.min(SEGMENTS, score === 0 ? 1 : score)
  return (
    <div className="flex flex-col gap-1.5" aria-live="polite">
      <div className="flex items-center gap-1.5">
        {Array.from({ length: SEGMENTS }, (_, i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full ${i < filled ? segmentColor(score) : 'bg-ostrel-line'}`}
          />
        ))}
        <span
          className={`ml-1 text-[10px] font-semibold uppercase tracking-widest ${
            meetsMinimum ? 'text-ostrel-ink-muted' : 'text-ostrel-danger'
          }`}
        >
          {meetsMinimum ? label : 'Too short'}
        </span>
      </div>
      <p className="text-[11px] leading-relaxed text-ostrel-ink-muted">{hint}</p>
    </div>
  )
}
